export const messages = {
  en: {
    communityPayment: {
      title: 'Community Payment',
      search: 'Search',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      confirmDelete: 'Confirm Delete',
      paymentName: 'Name',
      communityName: 'Community',
      paymentVendor: 'Payment Vendor',
      paymentScope: 'Payment Scope',
      status: 'Status',
      createTime: 'Create Time',
      instruction: 'Instruction',
      operation: 'Operation',
      communityFee: 'Community Fee',
      tempParkingFee: 'Temporary Parking Fee',
      specificFee: 'Specific Fee Item',
      enabled: 'Enabled',
      disabled: 'Disabled',
      selectCommunity: 'Select Community',
      selectStatus: 'Select Status',
      selectVendor: 'Select Vendor',
      selectScope: 'Select Scope',
      selectFeeItem: 'Select Fee Item',
      merchantCert: 'Merchant Certificate (.p12)',
      uploadFile: 'Upload Attachment',
      cancel: 'Cancel',
      save: 'Save',
      requiredField: 'Required field'
    },
    addCommunityPayment: {
      title: 'Add Payment',
      namePlaceholder: 'Please enter name',
      vendorPlaceholder: 'Please select vendor',
      scopePlaceholder: 'Please select scope',
      remarkPlaceholder: 'Optional, usage instructions'
    },
    editCommunityPayment: {
      title: 'Edit Payment',
      statusPlaceholder: 'Please select status'
    },
    deleteCommunityPayment: {
      title: 'Delete Confirmation',
      message: 'Are you sure to delete this payment configuration?'
    }
  },
  zh: {
    communityPayment: {
      title: '小区支付',
      search: '查询',
      add: '添加',
      edit: '修改',
      delete: '删除',
      confirmDelete: '确认删除',
      paymentName: '名称',
      communityName: '小区名称',
      paymentVendor: '支付厂家',
      paymentScope: '支付范围',
      status: '状态',
      createTime: '创建时间',
      instruction: '使用说明',
      operation: '操作',
      communityFee: '小区费用',
      tempParkingFee: '临时停车费',
      specificFee: '指定费用项',
      enabled: '启用',
      disabled: '停用',
      selectCommunity: '请选择小区',
      selectStatus: '请选择状态',
      selectVendor: '请选择厂家',
      selectScope: '请选择范围',
      selectFeeItem: '请选择费用项',
      merchantCert: '商户证书(.p12)',
      uploadFile: '上传附件',
      cancel: '取消',
      save: '保存',
      requiredField: '必填项'
    },
    addCommunityPayment: {
      title: '添加支付',
      namePlaceholder: '必填，请填写名称',
      vendorPlaceholder: '必填，请选择支付厂家',
      scopePlaceholder: '必填，请选择支付范围',
      remarkPlaceholder: '选填，请填写使用说明'
    },
    editCommunityPayment: {
      title: '修改支付',
      statusPlaceholder: '必填，请选择状态'
    },
deleteCommunityPayment: {
      title: '删除确认',
      message: '确定删除支付配置'
    }
  },
  'zh-TW': {
    communityPayment: {
      title: '小區支付',
      search: '查詢',
      add: '添加',
      edit: '修改',
      delete: '刪除',
      confirmDelete: '確認刪除',
      paymentName: '名稱',
      communityName: '小區名稱',
      paymentVendor: '支付廠家',
      paymentScope: '支付範圍',
      status: '狀態',
      createTime: '創建時間',
      instruction: '使用說明',
      operation: '操作',
      communityFee: '小區費用',
      tempParkingFee: '臨時停車費',
      specificFee: '指定費用項',
      enabled: '啟用',
      disabled: '停用',
      selectCommunity: '請選擇小區',
      selectStatus: '請選擇狀態',
      selectVendor: '請選擇廠家',
      selectScope: '請選擇範圍',
      selectFeeItem: '請選擇費用項',
      merchantCert: '商戶證書(.p12)',
      uploadFile: '上傳附件',
      cancel: '取消',
      save: '保存',
      requiredField: '必填項'
    },
    addCommunityPayment: {
      title: '添加支付',
      namePlaceholder: '必填，請填寫名稱',
      vendorPlaceholder: '必填，請選擇支付廠家',
      scopePlaceholder: '必填，請選擇支付範圍',
      remarkPlaceholder: '選填，請填寫使用說明'
    },
    editCommunityPayment: {
      title: '修改支付',
      statusPlaceholder: '必填，請選擇狀態'
    },
    deleteCommunityPayment: {
      title: '刪除確認',
      message: '確定刪除支付配置'
    }
  }
}